import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { ReturnToLink } from '@/components/ReturnToLink';
import { ROUTES } from '@/router';

type Props = {
  isDeletable: boolean;
  isEditable: boolean;
  isEditing: boolean;
  isSaving: boolean;
  onEditChange: (isEditing: boolean) => void;
  onDelete: () => void;
};

const UserDetailHeader = ({
  isDeletable,
  isEditable,
  isEditing,
  isSaving,
  onEditChange,
  onDelete,
}: Props) => {
  return (
    <div className="flex items-center justify-between gap-6 max-md:flex-col max-md:items-start max-md:gap-4">
      <ReturnToLink route={ROUTES.users.path} routeName={<Trans>Users & Roles</Trans>} />
      <div className="flex items-center gap-4 max-md:w-full max-md:justify-end">
        <PendoPlaceholder />
        {isEditable && isEditing ? (
          <>
            <Button type="button" disabled={isSaving} onClick={() => onEditChange(false)}>
              <Trans>Cancel</Trans>
            </Button>
            <Button variant="primary" type="submit" isLoading={isSaving}>
              <Trans>Save</Trans>
            </Button>
          </>
        ) : (
          <>
            {isEditable && (
              <Button type="button" onClick={() => onEditChange(true)}>
                <Trans>Edit User</Trans>
              </Button>
            )}
            {isDeletable && (
              <Button type="button" danger onClick={() => onDelete()}>
                <Trans>Delete User</Trans>
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UserDetailHeader;
